import { Link } from "wouter";

/*
 * The routes M2 onwards fills. Each is a placeholder now so that routing,
 * the onboarding gate and the deep-link shape are exercised end to end, and
 * the page that replaces one inherits all three.
 */

export function Home() {
  return (
    <main>
      <h1>Karvstokk</h1>
      <p>Countersigned documents, verifiable by anyone.</p>
      <Link href="/start">Create a Profile</Link>
    </main>
  );
}

/**
 * The counterparty's capability link, `/sign/{envelopeOpenedUID}#{capabilityToken}`
 * (§5.3). It onboards a first-time signer (§5.4), so it is an onboarding
 * route. The token is in the fragment and this component never reads it yet.
 */
export function Sign({ envelope }: { envelope: string }) {
  return (
    <main>
      <h1>Sign</h1>
      <p>Envelope {envelope}</p>
    </main>
  );
}

/** Verify (§5.6). Public, and onboards nobody, so it is never gated. */
export function Verify({ profile }: { profile: string }) {
  return (
    <main>
      <h1>Verify</h1>
      <p>Profile {profile}</p>
    </main>
  );
}

export function NotFound() {
  return (
    <main>
      <h1>Page not found</h1>
      <Link href="/">Go to Karvstokk</Link>
    </main>
  );
}
